/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Gateway_Sub_Cancellation_Scheduled_BodyInputs */



/**
* | output |
* | --- |
* | "Your Gateway subscription ends on {date}. You'll keep access until then." |
*
* @param {Gateway_Sub_Cancellation_Scheduled_BodyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const gateway_sub_cancellation_scheduled_body = /** @type {((inputs: Gateway_Sub_Cancellation_Scheduled_BodyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gateway_Sub_Cancellation_Scheduled_BodyInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Dein Gateway-Abonnement endet am ${i?.date}. Bis dahin behältst du vollen Zugriff.`)
	return /** @type {LocalizedString} */ (`Your Gateway subscription ends on ${i?.date}. You'll keep access until then.`)
});